import ErrorWithToast from "./ErrorWithToast";

class BoletosOffline extends ErrorWithToast{
  constructor() {
    super("Portal de boletos está offline");
  }
}

export default BoletosOffline;
